/* tslint:disable */
/* eslint-disable */
/**
 * ciselniky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Kontakt
 */
export interface Kontakt {
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'telefon'?: string;
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Kontakt
     */
    'adresa'?: string;
}
/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid': string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'nazovVGenitive'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'identifikator'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uplnyNazov'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'legislativna'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'technicka'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Organizacia
     */
    'verejna'?: boolean;
    /**
     * 
     * @type {Kontakt}
     * @memberof Organizacia
     */
    'kontakt'?: Kontakt;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizacnaSkupinaEnum = {
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    Pov: 'POV',
    Vestnik: 'VESTNIK',
    SpravcaAktuEu: 'SPRAVCA_AKTU_EU',
    Gestor: 'GESTOR',
    NotifikovatAktyEu: 'NOTIFIKOVAT_AKTY_EU',
    SchvalovatelGestora: 'SCHVALOVATEL_GESTORA',
    NotifikovatPredsedaVlady: 'NOTIFIKOVAT_PREDSEDA_VLADY'
} as const;

export type OrganizacnaSkupinaEnum = typeof OrganizacnaSkupinaEnum[keyof typeof OrganizacnaSkupinaEnum];



/**
 * OrganizaciaListExternalApi - axios parameter creator
 * @export
 */
export const OrganizaciaListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizaciaList: async (typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizacie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typOrganizacnejSkupiny !== undefined) {
                localVarQueryParameter['typOrganizacnejSkupiny'] = typOrganizacnejSkupiny;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (ldap !== undefined) {
                localVarQueryParameter['ldap'] = ldap;
            }

            if (nazov !== undefined) {
                localVarQueryParameter['nazov'] = nazov;
            }

            if (legislativna !== undefined) {
                localVarQueryParameter['legislativna'] = legislativna;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizaciaListExternalApi - functional programming interface
 * @export
 */
export const OrganizaciaListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizaciaListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Organizacia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizaciaListExternalApi.getOrganizaciaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizaciaListExternalApi - factory interface
 * @export
 */
export const OrganizaciaListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizaciaListExternalApiFp(configuration)
    return {
        /**
         * List of organizacia
         * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
         * @param {Array<string>} [ids] List of ids for organizacna skupina
         * @param {boolean} [ldap] Filter by ldap attribute
         * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
         * @param {boolean} [legislativna] Filter by legislativna attribute
         * @param {number} [limit] max number of results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, limit?: number, options?: any): AxiosPromise<Array<Organizacia>> {
            return localVarFp.getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizaciaListExternalApi - object-oriented interface
 * @export
 * @class OrganizaciaListExternalApi
 * @extends {BaseAPI}
 */
export class OrganizaciaListExternalApi extends BaseAPI {
    /**
     * List of organizacia
     * @param {OrganizacnaSkupinaEnum} [typOrganizacnejSkupiny] Type of organizacnaSkupina.
     * @param {Array<string>} [ids] List of ids for organizacna skupina
     * @param {boolean} [ldap] Filter by ldap attribute
     * @param {string} [nazov] Filter by hladanyNazov or skratenyNazov
     * @param {boolean} [legislativna] Filter by legislativna attribute
     * @param {number} [limit] max number of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizaciaListExternalApi
     */
    public getOrganizaciaList(typOrganizacnejSkupiny?: OrganizacnaSkupinaEnum, ids?: Array<string>, ldap?: boolean, nazov?: string, legislativna?: boolean, limit?: number, options?: RawAxiosRequestConfig) {
        return OrganizaciaListExternalApiFp(this.configuration).getOrganizaciaList(typOrganizacnejSkupiny, ids, ldap, nazov, legislativna, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



